import { render, staticRenderFns } from "./ImportVehicleContractsTable.vue?vue&type=template&id=8495dad4&scoped=true"
import script from "./ImportVehicleContractsTable.vue?vue&type=script&lang=ts"
export * from "./ImportVehicleContractsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495dad4",
  null
  
)

export default component.exports